import Vue from 'vue'
import VueComponent from './component'
import VueToastr from './toastr'

Vue.use(VueComponent)

Vue.use(VueToastr)